import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const LikeChatExercises = lazyWithPreload(
  () => import('./LikeChatExercises'),
)
